import React from "react";
import { Switch, Row, Col, Collapse, Form } from "antd";

const { Panel } = Collapse;

const RoleProjectPermission = ({ selectHmg, updateInitialValue }) => {
  const projectPermissionInitailValue = (hmgId) => {
    let initialValue = true;
    if (
      updateInitialValue?.role_data?.project_permissions
        ?.not_allowed_project_list &&
      updateInitialValue.role_data.project_permissions.not_allowed_project_list.find(
        (e) => e === hmgId
      )
    ) {
      initialValue = false;
    }
    return initialValue;
  };

  return (
    <Collapse defaultActiveKey={["project_permissions_1"]} expandIconPosition="end">
      <Panel header="Project Permissions" key="project_permissions_1">
        <div className="is_form_2_a">
          {selectHmg.map((d) => (
            <div className="is_form_2_aa" key={d.primary_hmg_id}>
              <Row>
                <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                  <label>
                    {d.hmg_name} - {d.project_name}
                  </label>
                </Col>

                <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                  <Row>
                    <Col xxl={3} xl={6} lg={6} sm={8}>
                      <Form.Item
                        name={[`project_permission_list`,d.primary_hmg_id]}
                        valuePropName="checked"
                        initialValue={projectPermissionInitailValue(
                          d.primary_hmg_id
                        )}
                        style={{
                          borderBottom: "none",
                        }}
                      >
                        <Switch />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          ))}
        </div>
      </Panel>
    </Collapse>
  );
};

export default RoleProjectPermission;
